import { Table } from "antd";
import React from "react";
import { vozvradData } from "../Form/formData";
import { newData } from "../Form/TableData";
import AddModal from "../Modal";

function Vozvarat() {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
    },

    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Klient",
      dataIndex: "klient",
    },
    {
      title: "Sklad",
      dataIndex: "sklad",
    },
    {
      title: "Kol-ov komplektov",
      dataIndex: "kol-ov_komplektov",
    },
    {
      title: "Kol-ov madelov",
      dataIndex: "kol-ov_madelov",
    },
    {
      title: "Kommentarii",
      dataIndex: "kommentarii",
    },
  ];
  return (
    <>
      <AddModal
        title={"Bозврат"}
        stil={"stil"}
        width={1400}
        form={vozvradData}
        columnsAll={vozvradData[0].columns}
        columnsAll2={vozvradData[0].columns1}
        table={newData}
        button={true}
      />
      <div className="mt-2">
        <Table columns={columns} />
      </div>
    </>
  );
}

export default Vozvarat;
